import { differenceInMinutes } from "date-fns";

import { Box, Flex } from "@/components/layout/flexbox";
import { isCloseEarlyComponent } from "@/components/pages_logged_in/program/components/utils";
import { DateTimeDisplay } from "@/components/pieces/DateTimeDisplay";

interface ProgramComponentDateViewProps {
  targetStartDate?: string | null;
  targetDueDate?: string | null;
  targetEndDate?: string | null;
  closedAt?: string | null;
  isPointInTime?: boolean;
  showDuration?: boolean;
}

export function ProgramComponentDateView({
  targetStartDate,
  targetDueDate,
  targetEndDate,
  closedAt,
  isPointInTime = false,
  showDuration = false,
}: ProgramComponentDateViewProps) {
  const duration =
    targetEndDate && targetStartDate
      ? differenceInMinutes(new Date(targetEndDate), new Date(targetStartDate))
      : 0;
  if (isPointInTime) {
    return targetStartDate ? (
      <Flex className="xs:text-sm text-subtext font-normal md:text-base">
        <DateTimeDisplay
          time={targetStartDate}
          formatString="MMMM d 'at' h:mm a"
          showDuration={showDuration}
          duration={duration}
        />
      </Flex>
    ) : null;
  }
  const isCloseEarly = isCloseEarlyComponent({ closedAt, targetEndDate });
  const endDate = closedAt || targetDueDate || targetEndDate;

  if (targetStartDate && endDate) {
    return (
      <Flex className="xs:text-sm text-subtext flex-wrap font-normal md:text-base">
        <DateTimeDisplay time={targetStartDate} formatString="MMM do" />
        &nbsp;-&nbsp;
        <DateTimeDisplay time={endDate} formatString="MMM do" />
        {isCloseEarly && (
          <Box display={"inline-block"} ml={1}>
            (ended early)
          </Box>
        )}
      </Flex>
    );
  }

  return null;
}
